import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { InvoicePreviewRibbon } from '@features/invoices/elements/InvoicePreviewRibbon'

import { useInvoice } from '../../../../contexts/invoiceContext'
import { useDisplayInvoiceDetailsCard } from '../../../../hooks/useDisplayInvoiceDetailsCard'
import { invoiceStatusInfoMap } from './constants/invoiceStatusInfoMap'

export const InvoiceStatusCornerRibbon = (): ReactElement | null => {
  const { t } = useTranslation()
  const { invoice } = useInvoice()

  const { shouldDisplayStatus } = useDisplayInvoiceDetailsCard()

  const status = invoice?.status?.status
  const { tKey, variant } = (status && invoiceStatusInfoMap[status]) || {}

  if (!shouldDisplayStatus || !tKey || !variant) {
    return null
  }

  return <InvoicePreviewRibbon text={t(tKey)} variant={variant} />
}
